// Module
var code = `<rbs-empty-header></rbs-empty-header> <rb-competitive-bid-view load-bid-function="VM.loadBidFunction" load-bid-options="VM.loadBidOptions" recipient-email-address-fn="VM.recipientEmailAddressFn" token="VM.token" direct="VM.direct"></rb-competitive-bid-view> `;
// Exports
export default code;